import { GeneralActions, GENERAL_ACTION_TYPE } from './general-type';
import { RootState } from '../root-reducer';
import { MODAL_TYPE } from './general-constant';

export enum GENERAL_STATE_KEY {
  COUNT = 'count',
  MODAL = 'modal',
  TNC_MODAL = 'tncModal',
  IS_MAINTENANCE = 'IS_MAINTENANCE',
  CHECK_BROWSER_NOT_SUPPORT = 'CHECK_BROWSER_NOT_SUPPORT',
  REMOTE_CONFIG = 'remoteConfig'
}
export type MODAL = {
  visible: boolean,
  onOk?: any,
  onConfirm?: any,
  onCancel?: any,
  type?: MODAL_TYPE,
  modalImage?: any,
  modalImageId?: string,
  modalIcon?: any,
  modalTitle?: string,
  modalContent?: any,
  modalTitleId?: string,
  modalContentId?: string,
  onOkText?: string,
  onOkTextId?: string,
  onCancelText?: string,
  onCancelTextId?: string,
  modalListContent?: any,
  clickClosable?: boolean,
  afterClose?: any,
  isEdited?: any,
  escClosable?: boolean,
  resetReload?: any,
  onSaveAndLeave?: any,
  onLeaveOnly?: any,
  batchReportStart?: string,
  batchReportEnd?: string,
  values?: any,
  valuesTitle?: any,
  valuesContent?: any,
  valueId?: any,
  valueText?: any,
  isBatchTimePeriod?: boolean,
  merchantReportType?: any,
  piecesPerPackOption?: any,
  piecesPerPackOption2Input?: any,
  weightSizeLimitOption?: any,
  weightLimitOption1Input?: number,
  weightLimitSelect?: any,
  sizeLimitSelect?: any,
  weightUnitId?: any,
  sizeLimitId?: any,
};

export type TNC_MODAL = {
  visible: boolean,
  contentHtml?: string,
  tncId?: number
};

export type GeneralState = {
  [GENERAL_STATE_KEY.COUNT]?: number,
  [GENERAL_STATE_KEY.MODAL]?: MODAL,
  [GENERAL_STATE_KEY.TNC_MODAL]?: TNC_MODAL,
  [GENERAL_STATE_KEY.IS_MAINTENANCE]: boolean,
  [GENERAL_STATE_KEY.CHECK_BROWSER_NOT_SUPPORT]: boolean,
  [GENERAL_STATE_KEY.REMOTE_CONFIG]?: Array<{ group: string, key: string, value: string }>
};

const initialState: GeneralState = {
  [GENERAL_STATE_KEY.COUNT]: 0,
  [GENERAL_STATE_KEY.MODAL]: {
    visible: false,
    onOk: null,
    type: MODAL_TYPE.DEFAULT,
    modalTitle: '',
    modalContent: ''
  },
  [GENERAL_STATE_KEY.TNC_MODAL]: {
    visible: false,
    contentHtml: undefined
  },
  [GENERAL_STATE_KEY.IS_MAINTENANCE]: false,
  [GENERAL_STATE_KEY.CHECK_BROWSER_NOT_SUPPORT]: false
};

export const generalReducers = (state = initialState, action: GeneralActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case GENERAL_ACTION_TYPE.SET_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const generalStateSelector = (key: GENERAL_STATE_KEY) => (state: RootState) => state.general[key];
